<template>
  <div>
    <EstatisticasBeneficios class="my-4" ref="estatisticas" />

    <hr class="my-4" />

    <b-form-group label="Moeda:">
      <SelectMoeda v-model="oportunidade.moeda_id" />
      <b-form-invalid-feedback :state="validateState('moeda_id')">
        <span v-if="!$v.oportunidade.moeda_id.required"
          >Moeda é um campo obrigatório.</span
        >
      </b-form-invalid-feedback>
    </b-form-group>

    <b-row>
      <b-col>
        <b-form-group label="Valor total da oportunidade:">
          <NumberFormat
            v-model="oportunidade.valor_total"
            placeholder="Valor total da oportunidade"
            :readonly="oportunidade.valor_total_calculado == 1"
            @blur="guardarTotal()"
            :state="validateState('valor_total')"
          />
          <b-form-checkbox
            v-model="oportunidade.valor_total_calculado"
            :value="1"
            :unchecked-value="0"
            class="input-total-calculado"
            size="sm"
            @change="changeCalculado()"
            >Calcular automaticamente
          </b-form-checkbox>
          <b-form-invalid-feedback>
            <span v-if="!$v.oportunidade.valor_total.decimal"
              >Valor Total é um campo do tipo decimal.</span
            >
          </b-form-invalid-feedback>
        </b-form-group>
        <b-button-group
          size="sm"
          v-if="oportunidade.valor_total_calculado != 1"
        >
          <b-button class="bg-yellow" @click="setValor('valor_total', 'media')"
            >Usar Média</b-button
          >
          <b-button
            class="bg-green text-white"
            @click="setValor('valor_total', 'maior')"
            >Usar Maior</b-button
          >
          <b-button variant="danger" @click="setValor('valor_total', 'menor')"
            >Usar menor</b-button
          >
        </b-button-group>
      </b-col>
      <b-col>
        <b-form-group label="Descrição do Valor Total :">
          <b-form-textarea v-model="oportunidade.valor_total_descricao" />
        </b-form-group>
      </b-col>
    </b-row>

    <hr class="my-4" />

    <b-row>
      <b-col>
        <b-form-group label="Valor máximo por projeto:">
          <NumberFormat
            v-model="oportunidade.valor_projeto"
            placeholder="Valor máximo por projeto"
            :state="validateState('valor_projeto')"
          />
          <b-form-invalid-feedback>
            <span v-if="!$v.oportunidade.valor_projeto.decimal"
              >Valor Projeto é um campo do tipo decimal.</span
            >
          </b-form-invalid-feedback>
        </b-form-group>

        <b-button-group size="sm">
          <b-button
            class="bg-yellow"
            @click="setValor('valor_projeto', 'media')"
            >Usar Média</b-button
          >
          <b-button
            class="bg-green text-white"
            @click="setValor('valor_projeto', 'maior')"
            >Usar Maior</b-button
          >
          <b-button variant="danger" @click="setValor('valor_projeto', 'menor')"
            >Usar menor</b-button
          >
          <b-button variant="exitos" @click="setValor('valor_projeto', 'total')"
            >Usar Total</b-button
          >
        </b-button-group>
      </b-col>
      <b-col>
        <b-form-group label="Descrição do Valor do Projeto:">
          <b-form-textarea v-model="oportunidade.valor_projeto_descricao" />
        </b-form-group>
      </b-col>
    </b-row>

    <hr class="my-4" />

    <h3>Valores e Beneficios</h3>

    <b-alert variant="info" show v-if="!oportunidade.id">
      É preciso salvar a oportunidade antes de registrar beneficios e emendas
      parlamentares
    </b-alert>

    <div v-else>
      <Beneficios class="my-4" />
      <BeneficiosConcedente class="my-4" />
      <Emendas class="my-4" />
    </div>
  </div>
</template>

<script>
import SelectMoeda from "@/modules/moedas/Components/SelectMoeda.vue";
import Beneficios from "./Valores/Beneficios.vue";
import BeneficiosConcedente from "./Valores/BeneficioConcedente.vue";
import Emendas from "./Valores/Emendas.vue";
import EstatisticasBeneficios from "./Valores/EstatisticasBeneficios.vue";
import { validationMixin } from "vuelidate";
import { required, decimal } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import NumberFormat from "@/components/Form/NumberFormat.vue";

export default {
  mixins: [validationMixin],
  components: {
    SelectMoeda,
    Beneficios,
    BeneficiosConcedente,
    Emendas,
    EstatisticasBeneficios,
    NumberFormat,
  },
  data() {
    return {
      valor_total: 0,
    };
  },
  validations: {
    oportunidade: {
      moeda_id: {},
      valor_total: {
        decimal,
      },
      valor_projeto: {
        decimal,
      },
    },
  },
  computed: {
    ...mapState("oportunidades", ["oportunidade", "oportunidade_estatisticas"]),
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.oportunidade[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.oportunidade.$touch();
      return !this.$v.oportunidade.$anyError;
    },
    setValor(index, tipo) {
      switch (tipo) {
        case "media":
        case "maior":
        case "menor":
        case "total":
          const value = this.$refs.estatisticas[tipo];
          if (value) this.oportunidade[index] = value;
          break;
      }
    },
    changeCalculado() {
      if (this.oportunidade.valor_total_calculado) {
        this.valor_total = this.oportunidade.valor_total;
        this.setValor("valor_total", "total");
      } else {
        this.oportunidade.valor_total = this.valor_total;
      }
    },
    guardarTotal() {
      this.valor_total = this.oportunidade.valor_total;
    },
  },
  // watch: {
  //   oportunidade_estatisticas: {
  //     deep: true,
  //     handler: function (values) {
  //       this.setValor("valor_total", "total");
  //     },
  //   },
  // },
};
</script>

<style lang="scss">
.input-total-calculado {
  padding-left: 2rem;

  .custom-control-label {
    &:after {
      left: -2rem !important;
    }

    &:before {
      left: -2rem !important;
    }
  }
}
</style>
